import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import * as Scroll from 'react-scroll';
import { setVideoPosition } from 'actions/ui';

import './insights.css';
import { SystemText, Tabs } from 'e4shared';
import { capitalize } from '@material-ui/core';
import Pdf from './pdf';

export const getSeconds = t => {
    const s = t.split('.')[0];
    const a = s.split(':');
    const seconds = a.length > 0 ? parseInt(a[a.length - 1], 10) : 0;
    const mins = a.length > 1 ? parseInt(a[a.length - 2], 10) : 0;
    const hours = a.length > 2 ? parseInt(a[a.length - 3], 10) : 0;
    return seconds + mins * 60 + hours * 3600;
};

export const formatSeconds = t => {
    const s = t.split('.')[0];
    return s;
};

export const Insights = ({ task }) => {
    let clock = null;
    const dispatch = useDispatch();
    const [seconds, setSeconds] = React.useState(60);
    const [tab, setTab] = React.useState('insights');
    const [search, setSearch] = React.useState('');
    const [insights, setInsights] = React.useState({});
    const [transcript, setTranscript] = React.useState([]);
    const videoTime = useSelector(state => state.ui.videoTime);
    const st = (path, ...rest) => SystemText(`Objective/Pitchback/${path}`, ...rest);

    const counter = () => {
        clock = setTimeout(() => {
            if (seconds > 0) {
                setSeconds(seconds - 1);
                counter();
            } else {
                clearTimeout(clock);
            }
        }, 1000);
    };

    React.useEffect(() => {
        const childElement = document.getElementById('transcript-current');
        const parentElement = document.getElementById('transcript-scroll');
        if (childElement && parentElement) {
            parentElement.scrollTop = childElement.offsetTop - 20;
        }
    }, []);

    React.useEffect(() => {
        if (search) {
            setTranscript(
                task.video?.insights?.transcript.filter(t => t.text.toLowerCase().indexOf(search.toLowerCase()) >= 0)
            );
        } else {
            setTranscript(task.video?.insights?.transcript);
        }
    }, [search, task.video.insights.transcript]);

    if (!task || !task.insights_Id) return null;

    const getSpeakerClass = (s, e) => {
        const start = s ? getSeconds(s) : 0;
        const end = e ? getSeconds(e) : 0;
        return start <= videoTime && end >= videoTime ? 'btn-info' : '';
    };

    return (
        <>
            <Tabs
                style="clean"
                role="tabpanel"
                tab={tab}
                setTab={tab => setTab(tab)}
                tabNames={{
                    transcript: st('Tabs/Transcript'),
                    insights: st('Tabs/Insights'),
                }}
                tabs={['insights', 'transcript']}
            ></Tabs>

            {tab === 'transcript' && (
                <div className="mt20 tab-content">
                    {task.video?.insights?.transcript?.length > 0 && (
                        <div className="form-group video-insights">
                            <div className="flex flex-center" id="transcript-search">
                                <i className="fa fa-search mr10" />
                                <input
                                    className="flex-grow"
                                    type="text"
                                    value={search}
                                    onChange={e => setSearch(e.target.value)}
                                    placeholder={st('Search')}
                                />
                                <Pdf transcript={transcript} objective={task} />
                            </div>
                            {transcript.length === 0 && <div className="mt20">{st('Transcript/NoResults')}</div>}
                            <div
                                className="btn-row"
                                id="transcript-scroll"
                                style={{ maxHeight: '200px', overflowY: 'auto' }}
                            >
                                {transcript.map((t, i) => {
                                    const hasInstances = t.instances && t.instances.length > 0;
                                    const speakerClass = hasInstances
                                        ? getSpeakerClass(t.instances[0].start, t.instances[0].end)
                                        : '';
                                    return t.text ? (
                                        <div className="flex flex-center" key={`transcript-${t.id}`}>
                                            {speakerClass && <Scroll.Element id="transcript-current" />}
                                            <button
                                                className={`btn btn-grey btn-anycase btn-xs ${speakerClass}`}
                                                onClick={
                                                    !hasInstances
                                                        ? undefined
                                                        : () => dispatch(setVideoPosition(getSeconds(t.instances[0].start)))
                                                }
                                            >
                                                {t.instances[0].start?.split('.')[0]}
                                            </button>
                                            <span className="ml10">{t.text}</span>
                                        </div>
                                    ) : null;
                                })}
                            </div>
                        </div>
                    )}
                </div>
            )}
            {tab === 'insights' && (
                <div className="mt20 tab-content">
                    {!task.video?.insights && <span>{st('Tabs/Insights/NoResults')}</span>}
                    {['keywords', 'sentiments', 'topics'].map(insight => {
                        if (task.video?.insights[insight]?.length === 0) return null;
                        const collection = task.video?.insights[insight];
                        if (!collection) return null;
                        const selectedId = insights[insight] || 1;
                        return (
                            <div className="mb10">
                                <label className="mr5">{st(`Insights/${capitalize(insight)}`)}:</label>
                                <div className="mb10">
                                    {collection
                                        .sort((a, b) => (a.instances.length > b.instances.length ? -1 : 1))
                                        .map((k, i) => {
                                            const text = k.text || k.name || k.sentimentType;
                                            return i >= 10 ? null : (
                                                <button
                                                    key={`keyword-${i}`}
                                                    onClick={() => {
                                                        const temp = { ...insights };
                                                        temp[insight] = k.id;
                                                        setInsights(temp);
                                                    }}
                                                    className={`btn btn-sm mr5 ${
                                                        selectedId === k.id ? 'btn-primary' : 'btn-grey'
                                                    }`}
                                                >
                                                    {text} ({k.instances.length})
                                                </button>
                                            );
                                        })}
                                </div>
                                <div>
                                    {collection
                                        .find(c => c.id === selectedId)
                                        .instances.map((x, s) => (
                                            <button
                                                data-testid="button-seconds"
                                                key={`instance-${s}`}
                                                className={`btn btn-sm mr5`}
                                                onClick={() => dispatch(setVideoPosition(getSeconds(x.start) - 1))}
                                            >
                                                {formatSeconds(x.start)}
                                            </button>
                                        ))}
                                </div>
                            </div>
                        );
                    })}
                </div>
            )}
        </>
    );
};

export default Insights;
